import React from "react";

import QuestionsBox from "./QuestionsBox";

const Reflections = (props) => {
    return (
        <div className={"reflection-item  " + props.className} id="reflection">
            <div className="reflection-item-title">
                <div className="title-text">Reflections</div>
            </div>

            <div className="title-text mb-4">{props.description}</div>
            <div className="questions-box-wrapper">
                {
                    props.questions.sort((a, b) => a.sequence - b.sequence).map((question, index) => {
                        return <QuestionsBox key={`ksdhfnvcb${index}`} {...question} handleAnswerChange={props.handleAnswerChange} />;
                    })
                }
            </div>
        </div>
    );
};

export default Reflections;